<template>
  <div class="con">
    <div class="con_title">{{ title }}</div>
    <div class="con_desc">
      e签宝面向企业组织、政务服务、个人用户等提供<span>全生态电子合同签名服务</span>，致力于利用技术降低信任成本，打造组织数字化闭环，降本增效。
    </div>
    <div class="con_list">
      <div class="text-list" v-for="(item, index) in pointTextList" :key="index">
        <div class="text1">
          <img class="img" :src="item.iconUrl" />
          <span>{{ item.text1 }}</span>
        </div>
        <div class="text2">{{ item.text2 }}</div>
        <div class="text3">{{ item.text3 }}</div>
        <div class="text4">{{ item.text4 }}</div>
        <div class="text4">{{ item.text5 }}</div>
        <div class="text4">{{ item.text6 }}</div>
      </div>
    </div>
    <div class="foot">
      <!-- <a class="btn" href="https://www.esign.cn/pcgw/sy/mfsy/mfsy/" target="_blank">免费试用</a> -->
      <div class="btn-wrap">
        <div class="btn" @click="showDialog">免费试用</div>
        <a v-show="$route.path === '/semnav' || $route.path === '/chunsheng'" class="ty-btn" href="https://www.esign.cn/cs/eqbtyzx/" target="_blank">体验Demo</a>
      </div>
      <div class="tips">数据来源：《2020中国电子签名生态大数据报告》</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    pointTextList: Array,
  },
  data() {
    return {
      openSwitch: 0,
    }
  },
  methods: {
    showDialog() {
      this.$emit('showDialog')
    },
  },
}
</script>

<style lang="less" scoped>
.con {
  height: 608px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  background: #fff;
  padding-top: 50px;
  padding-bottom: 60px;
}

.con_title {
  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 50px;
}

.con_desc {
  font-size: 16px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #666666;
  line-height: 22px;
  margin-top: 15px;
  margin-bottom: 25px;
  span {
    color:#E61717;
  }
}

.con_list {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1200px;
  .text-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 319px;
    padding-top: 35px;
    &:hover {
      background-color: #FCFCFC;
    }
    .text1 {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      .img {
        width: 35px;
        height: 52px;
        margin-right: 14px;
      }
      i {
        display: inline-block;
        width: 34px;
        height: 56px;
        background: linear-gradient(180deg, #E61717 0%, rgba(255, 255, 255, 0) 100%);
        margin-right: 5px;
      }
      span {
        font-size: 42px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 59px;
      }
    }
    .text2 {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 37px;
      margin-bottom: 15px;
    }
    .text3 {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
      margin-bottom: 15px;
    }
    .text4 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      margin-bottom: 9px;
    }
  }
}
.foot {
  position: relative;
  margin-top: 27px;
  display: flex;
  align-items: flex-end;
  .btn-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 145px;
    height: 40px;
    background: #E61717;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
  }
  .ty-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 145px;
    height: 40px;
    border: 1px solid #E61717;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #E61717;
    line-height: 20px;
    margin-left: 50px;
    border-radius: 4px;
  }
  .tips {
    position: absolute;
    width: 280px;
    left: 440px;
    font-size: 11px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 16px;
  }
}
.con_c {
  width: 1200px;
  height: 520px;
  margin: 40px auto;
  border: 1px solid #ececec;

  .con_c_title {
    height: 40px;
    width: 100%;
    display: flex;
    font-size: 16px;

    .t_left {
      width: 459px;
      line-height: 40px;
      background: #494949;
      text-align: center;
      color: #fff;
    }

    .t_right {
      width: 742px;
      line-height: 40px;
      text-align: center;
      background: #e61717;
      color: #fff;
    }
  }

  .tab_list {
    width: 100%;
    height: 119px;
    padding-left: 70px;
    padding-top: 25px;
    padding-right: 55px;
    cursor: pointer;
    border-bottom: 1px solid #ececec;

    .list_t {
      color: #e61717;
      font-size: 16px;
      font-family: '黑体';
      font-weight: 700;
    }

    .list_c {
      color: #333;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      margin-top: 5px;
    }
  }

  .con_c_con {
    width: 100%;
    height: 479px;
    display: flex;
    background: #fff;
  }

  .con_c_tabbox {
    width: 459px;
    background: #f7f7f7;

    .border-bt-0 {
      border-bottom: 0 !important;
    }

    .height-120 {
      height: 120px;
    }

    .active_listbg {
      background: #fff;
      border-left: 5px solid #e61717;
    }

    .no_active_listbg {
      background: #f7f7f7;
      border-left: 0;
    }
  }

  .con_subtitle {
    font-size: 14px;
    text-align: center;
    line-height: 28px;
  }

  .tab_con {
    width: 741px;
    padding-top: 30px;
    color: #333;
    border-bottom: 1px solid #ececec;

    img {
      width: 584px;
      height: 355px;
      display: flex;
      margin: 33px auto 0;
    }
  }
}
</style>
